import { EyeOutlined } from '@ant-design/icons';
import { Button, Empty, Typography } from 'antd';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import RCTable from 'components/custom-table/RCTable';
import { getFormatedDayDateAndTime } from 'utils';
import { getUIVersion } from 'utils/router-static-data';

const { Text } = Typography;

function PendingApprovalsTab({ tableDatas, togglePaginate, dispatchAction }) {
	const navigate = useNavigate();
	const isV2UI = getUIVersion() === 'new';

	const handleView = (record) => {
		navigate(`/trips/adhoc-request/${record.id}`);
	};

	const columns = [
		{
			title: 'Request ID',
			dataIndex: 'id',
			key: 'id',
			width: 100,
		},
		{
			title: 'Project',
			dataIndex: 'project_code',
			key: 'project_code',
			width: 150,
			render: (project_code, record) => {
				if (isV2UI) {
					return record?.project_name || '-';
				}
				return project_code || '-';
			},
		},
		{
			title: 'Client',
			dataIndex: 'client_name',
			key: 'client_name',
			width: 120,
		},
		{
			title: 'Movement',
			dataIndex: 'movement_type',
			key: 'movement_type',
			width: 120,
			render: (movement_type) => (
				<Text
					style={{
						backgroundColor: '#FFDDB3D9',
						color: '#000000',
						padding: '4px 8px',
						borderRadius: '12px',
						fontSize: '12px',
						fontWeight: '500',
						textAlign: 'center',
						display: 'inline-block',
					}}
				>
					{movement_type || 'Intercity'}
				</Text>
			),
		},
		{
			title: 'Vendor',
			dataIndex: 'vendor_name',
			key: 'vendor_name',
			width: 120,
		},
		{
			title: 'Trip Date/Time',
			dataIndex: 'expected_trip_date',
			key: 'expected_trip_date',
			width: 150,
			render: (date) => {
				if (!date) return '-';
				return `${getFormatedDayDateAndTime(date, 'trip_date').fomatedDate} ${
					getFormatedDayDateAndTime(date, 'trip_date').formatedTimeAMPM
				}`;
			},
		},
		{
			title: 'From',
			key: 'from_location',
			width: 120,
			render: (record) => {
				const parts = [record.source_city, record.source_state].filter(Boolean);
				return parts.join(', ') || '-';
			},
		},
		{
			title: 'To',
			key: 'to_location',
			width: 120,
			render: (record) => {
				const parts = [record.destination_city, record.destination_state].filter(Boolean);
				return parts.join(', ') || '-';
			},
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
			width: 120,
			render: (_, record) => (
				<Button type="link" icon={<EyeOutlined />} onClick={() => handleView(record)} />
			),
		},
	];

	return (
		<div style={{ marginTop: 16 }}>
			<RCTable
				rowKey="id"
				tableDatas={tableDatas}
				togglePaginate={togglePaginate}
				dispatchAction={dispatchAction}
				columns={columns}
				scroll={{ x: true }}
				locale={{
					emptyText: (
						<Empty
							description={<Text type="secondary">No pending approvals found</Text>}
						/>
					),
				}}
			/>
		</div>
	);
}

PendingApprovalsTab.propTypes = {
	tableDatas: PropTypes.array.isRequired,
	togglePaginate: PropTypes.array.isRequired,
	dispatchAction: PropTypes.func.isRequired,
};

export default PendingApprovalsTab;
